module.exports = __webpack_public_path__ + "img/hand.e2181bf2.svg";